// import { useEffect, useState } from 'react';
// import { Form, Button, Select } from 'antd';
// import { useHistory, useLocation } from 'react-router-dom';
// import EPSProvider from '../providers/EPSProvider';
// import { buyerKey } from '../constants';
// import { soliqRequests } from '../utils/soliqRequest';
// import putSignature from '../utils/putSignature';
// import { baseURL } from '../utils/axios_init';
// import { useUserDataStore } from '../shared/store/useUserDataStore';
// import { SoliqApi } from '../shared/api';
// const { Option } = Select;
// function Login() {
//   const setSelectedEDS = useUserDataStore((s) => s.setSelectedEDS);
//   const setAccessToken = useUserDataStore((s) => s.setAccessToken);
//   const setSoliqAccessToken = useUserDataStore((s) => s.setSoliqAccessToken);
//   const history = useHistory();
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);
//   const [ecpKeys, setEcpKeys] = useState([]);

import { useHistory, useLocation } from 'react-router-dom';
import { useUserDataStore } from '../shared/store';
import { UserApi } from '../shared/api';

//   useEffect(() => {
//     getData();
//   }, []);

//   const getData = async () => {
//     const tokens = location?.search?.split('?token=')[1];
//     const token = tokens?.split('&')[0];
//     const soliqToken = tokens?.split('&')[1].split('soliqToken=')[1];

//     if (token) {
//       setLoading(true);
//       localStorage.setItem('token', token);
//       localStorage.setItem('soliqToken', soliqToken);
//       setAccessToken(token);
//       setSoliqAccessToken(soliqToken);

//       setLoading(false);
//       history.push('/');
//       document.location.reload();
//     }
//   };

//   const login = async (res) => {
//     const selectedKey = JSON.parse(res?.inn);

//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append('inn', selectedKey.TIN);
//       // const response = await requests.Auth.login({ inn: selectedKey.TIN })
//       var response;
//       await fetch(`${baseURL}/seller/auth/login`, {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           'Accept-Language': 'uz',
//         },
//         body: formData,
//       })
//         .then((response) => response.json())
//         .then((data) => {
//           response = data;
//         })
//         .catch((error) => {
//           setLoading(false);
//         });
//       console.log('response', response);

//       if (response?.data) {
//         localStorage.setItem('token', response?.data?.token);
//         setAccessToken(response?.data?.token);
//         console.log('response?.data', response?.data);
//         localStorage.setItem('userData', JSON.stringify(response?.data) || {});
//         const data = { tin: selectedKey.TIN, inn: selectedKey.TIN };
//         const sign = await putSignature(data, selectedKey);
//         setSelectedEDS(selectedKey);
//         const resSoliq = await SoliqApi.login({ sign: sign });
//         localStorage.setItem('soliqToken', resSoliq?.data?.token?.access_token);
//         setSoliqAccessToken(resSoliq?.data?.token?.access_token);
//         setLoading(false);
//         history.push('/');
//         document.location.reload();
//       }
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//     }
//   };

//   const onFinish = (values) => {
//     login(values);
//   };
//   const statickey = () => {
//     if (ecpKeys?.length) {
//       return ecpKeys;
//     } else {
//       return [buyerKey];
//     }
//   };
//   return (
//     <>
//       <EPSProvider setEcpKeys={setEcpKeys} />

//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           flexDirection: 'column',
//           gap: '20px',
//           height: '100vh',
//         }}
//       >
//         <h2 className='text-2xl flex gap-2 '>Vasit Seller</h2>
//         <Form onFinish={onFinish} className='w-[400px]'>
//           <Form.Item
//             name='inn'
//             rules={[
//               {
//                 required: true,
//                 message: 'Please, select ecp!',
//               },
//             ]}
//           >
//             <Select size='large' className='min-h-[58px]'>
//               {statickey().map((item) => (
//                 <Option key={JSON.stringify(item)}>
//                   <div className='flex flex-col'>
//                     <span className='!m-0 !p-0'>{item.O}</span>
//                     <span className='text-sm !m-0 !p-0'>{item.CN}</span>
//                   </div>
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>

//           <Form.Item>
//             <Button block htmlType='submit' className='login-form-button' size='large' loading={loading}>
//               Sign in
//             </Button>
//           </Form.Item>
//         </Form>
//       </div>
//     </>
//   );
// }
// export default Login;

const Login = () => {
  const location = useLocation();
  const history = useHistory();
  const setAccessToken = useUserDataStore((s) => s.setAccessToken);
  const setSoliqAccessToken = useUserDataStore((s) => s.setSoliqAccessToken);
  const par = new URLSearchParams(location.search);
  const token = par.get('token');
  const soliqToken = par.get('soliqToken');
  const setUser = useUserDataStore((s) => s.setUser);
  const setSelectedEDS = useUserDataStore((s) => s.setSelectedEDS);

  const getUserMe = async () => {
    await UserApi.getUserMe().then((res) => {
      console.log('res', res);
      // localStorage.setItem('userData', JSON.stringify(res?.data));
      // setUser(res?.data);
      // setSelectedEDS(res?.data?.data);
    });
  };

  if (token) {
    localStorage.setItem('token', token);
    localStorage.setItem('soliqToken', soliqToken);
    setAccessToken(token);
    setSoliqAccessToken(soliqToken);
    history.push('/');
    getUserMe();
  } else {
    window.location.href = process.env.REACT_APP_REDIRECT_BUYER_URL;
    return null;
  }
};

export default Login;
